import { useContext } from "react"
import { IndoorMapContext } from "../IndoorMapContext"

export const useIndoorMap = () => {
  const values = useContext(IndoorMapContext)
  return values
}
